import { Component, Input, inject } from '@angular/core';
import { CommonUtilsService } from '@bepatient/common';
import { CoreRouterActionGoBack } from '@bepatient/core';

@Component({
  selector: 'bepatient-my-account-toolbar',
  templateUrl: './my-account-toolbar.component.html',
  styleUrls: ['./my-account-toolbar.component.scss'],
  standalone: false
})
export class MyAccountToolbarComponent {
  private commonUtils = inject(CommonUtilsService);

  @Input() title: string;
  @Input() color: string;
  @Input() icon: string;
  @Input() pageType: string;

  goBack(): void {
    this.commonUtils.storeDispatch(new CoreRouterActionGoBack());
  }
}
